import React from 'react';
import { Tooltip as CTooltip, TooltipProps as CTooltipProps } from '@chakra-ui/react';
import { Colors } from '@/styles/colors';

export type TooltipProps = CTooltipProps;

export const Tooltip: React.FC<TooltipProps> = ({ children, ...props }) => (
  <CTooltip
    openDelay={200}
    hasArrow
    bg={Colors.Blackcurrant_50}
    color={Colors.White}
    border={`1px solid ${Colors.Blackcurrant_40}`}
    {...props}
  >
    {children}
  </CTooltip>
);
